import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { ExperiencesService } from '@ordersnproducts/modules/shared/services/experiences.service';

export namespace DateTimeEnablerProvider {
  export class DisableScheduleMomentFormField extends BaseAsyncValue<boolean> {
    private experiencesService: ExperiencesService;

    getValue(): Observable<boolean> {
      this.experiencesService = this.injector.get(ExperiencesService);
      const improvedDco$ = this.experiencesService.experienceDcoEnabled$().pipe(
        take(1),
        map((improvedDcoEnabled) => {
          if (improvedDcoEnabled === false) {
            // if feature is disabled, this form field is not needed
            return true;
          }
          return false;
        }),
      );
      return improvedDco$;
    }
  }

  export class DisableDateFormField extends BaseAsyncValue<boolean> {
    private experiencesService: ExperiencesService;

    getValue(): Observable<boolean> {
      this.experiencesService = this.injector.get(ExperiencesService);
      const improvedDco$ = this.experiencesService.experienceDcoEnabled$().pipe(
        take(1),
        map((improvedDcoEnabled) => {
          if (improvedDcoEnabled) {
            // disable this form field if DCO is shown
            return true;
          }
          return false;
        }),
      );
      return improvedDco$;
    }
  }

  export class DisableTimeFormField extends BaseAsyncValue<boolean> {
    private experiencesService: ExperiencesService;

    getValue(): Observable<boolean> {
      this.experiencesService = this.injector.get(ExperiencesService);
      const improvedDco$ = this.experiencesService.experienceDcoEnabled$().pipe(
        take(1),
        map((improvedDcoEnabled) => {
          if (improvedDcoEnabled) {
            // disable this form field if DCO is shown
            return true;
          }
          return false;
        }),
      );
      return improvedDco$;
    }
  }
}
